import { render } from "./FAQSection.vue?vue&type=template&id=9ff5f97c&scoped=true"
import script from "./FAQSection.vue?vue&type=script&lang=js"
export * from "./FAQSection.vue?vue&type=script&lang=js"

import "./FAQSection.vue?vue&type=style&index=0&id=9ff5f97c&lang=scss&scoped=true"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff5f97c"]])

export default __exports__